<div class="row bottom-margin-5 padding-10 align-center">
  <span>{{composeIntroduction}}</span>
</div>
<div class="row subject-div">
  <div class="col s12 m2 l2 xl2">
    <div class="custom-padding">
      <span class="bold">Subject:</span>
    </div>
  </div>
  <div class="col s12 m10 l10 xl10">
    <kendo-textbox-container placeholder="Enter Subject">
      <input name="subjectTextBox" #subjectTextBox="ngModel" [(ngModel)]="subject" kendoTextBox id="subjectTextBox"
        (keyup)="keyup(subject, 1)" placeholder="Enter Subject" />
    </kendo-textbox-container>
  </div>
</div>
<div class="row topic-div">
  <div class="col s12 m2 l2 xl2">
    <div class="custom-padding"><span class="bold">Topic:</span></div>
  </div>
  <div class="col s12 m10 l10 xl10">
    <kendo-dropdownlist [data]="listItems" [valuePrimitive]="true" [textField]="'name'" [valueField]="'id'"
      [popupSettings]="{ popupClass: 'font-size-16 text-black' }" [defaultItem]="defaultItem"
      [(ngModel)]="selectedValue" ngDefaultControl>
    </kendo-dropdownlist>
  </div>
</div>
<div class="row message-div">
  <div class="col s12 m2 l2 xl2">
    <div class="custom-padding"><span class="bold">Message:</span></div>
  </div>
  <div class="col s12 m10 l10 xl10">
    <textarea name="messageTextBox" placeholder="Enter message" kendoTextArea [autoSize]="true" [maxlength]="maxLength"
      class="full-width text-area-height" #messageTextBox="ngModel" [(ngModel)]="messageVal" id="body-text"
      ngDefaultControl (keyup)="keyup(messageVal, 2)"></textarea>
    <div class="align-right">
      <span *ngIf="messageVal" class="word-count">{{messageVal.length}}/{{maxLength}}</span>
    </div>
  </div>
</div>
<div class="row margin-bottom-0">
  <div class="col s12 m12 l12 xl12 align-center">
    <button [disabled]="isDisabled()" class="btn waves-effect background-red waves-light" id="send-btn" (click)="send()"
      primary="true">Send</button>
  </div>
</div>
